import Vue from 'vue';
import vuex from 'vuex';
Vue.use(vuex);

export default new vuex.Store({
  state: {
    user: '',
    menu: {
      state: false
    },
    header: {
      title:''
    }
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js